export default __webpack_public_path__ + "static/media/doctor-sm.6e0f0851.png";